/*
 * @Author: Jason
 * @Date: 2020-09-11 14:03:51
 * @LastEditors: Jason
 * @LastEditTime: 2020-10-10 13:54:32
 */
const state = {
  total: 0,
  page: 0,
  pageIndex: 1,
  limit: 10,
  list: [],
  offset: 0,
  currentBaby: null
}

const mutations = {
  SET_BABY_LIST(state, { payload }) {
    state.total = payload.total
    state.list = payload.list
  },
  SET_BABY_OFFSET (state, { payload }) {
    state.limit = (payload && payload.limit) || 10
    state.offset = (payload && payload.offset) || 0
  },
  SET_BABY(state, { payload }) {
    state.currentBaby = payload
  },
  CREATE_BABY(state, { payload }) {
    state.list.unshift(payload.baby)
    if (state.list.length > state.limit) {
      state.list.pop()
    }
  }
}

const actions = {
  setBabyList({ commit }, payload) {
    // do something async
    commit('SET_BABY_LIST', {
      payload: payload
    })
  },
  setBabyOffset({ commit }, payload) {
    // do something async
    commit('SET_BABY_OFFSET', {
      payload: payload
    })
  },
  setBaby({ commit }, payload) {
    // do something async
    console.log(payload)
    commit('SET_BABY', {
      payload: payload
    })
  },
  createBaby({ commit }, payload) {
    // do something async
    commit('CREATE_BABY', {
      payload: payload
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Baby.js